// extracted by mini-css-extract-plugin
export default {"reactAdmin":"react-admin--n92D0uWU","content":"content--v2y5682U","page":"page--_4zVjWcr","empty":"empty--yGlTga45"};